@if (isActive() && currentStep()) {
  <div class="fixed inset-0 z-9998">
    <div
      class="tour-highlight absolute rounded-md pointer-events-none z-9999 transition-[top,left,width,height] duration-300"
      [ngStyle]="highlightStyle()"
      (click)="$event.stopPropagation()"
    ></div>
  </div>
  <div
    #popoverEl
    class="tour-popover fixed z-10001 w-[320px] max-w-[calc(100vw-24px)]"
    [ngStyle]="popoverStyle()"
    (click)="$event.stopPropagation()"
  >
    <div
      class="tour-popover__arrow tour-popover__arrow--{{
        popoverPosition()
      }} absolute h-[12px] w-[12px] rotate-45 bg-white"
      [ngStyle]="arrowStyle()"
    ></div>
    <div class="overflow-hidden rounded-md bg-white shadow-md">
      <div class="flex items-center justify-between px-3.5 pb-1.5 pt-3">
        <span class="font-bold text-slate-800">{{ currentStep()?.title }}</span>
        <p-button
          outlined
          size="small"
          variant="text"
          aria-label="بستن"
          icon="pi pi-times"
          severity="secondary"
          (onClick)="endTour()"
        >
        </p-button>
      </div>
      <p class="m-0 px-3.5 pb-2.5 pt-1 text-right text-slate-600">
        {{ currentStep()?.text }}
      </p>
      <div
        class="flex items-center justify-between border-t border-slate-100 px-3.5 pb-3 pt-2"
      >
        <span class="text-slate-400">
          {{ currentIndex() + 1 }} / {{ totalSteps }}
        </span>
        <div class="flex gap-1.5">
          @if (currentIndex() > 0) {
            <p-button
              label="قبلی"
              severity="secondary"
              (onClick)="showPreviousStep()"
            />
          }
          @if (currentIndex() < totalSteps - 1) {
            <p-button label="بعدی" (onClick)="showNextStep()" />
          }
          @if (currentIndex() === totalSteps - 1) {
            <p-button label="پایان" (onClick)="endTour()" />
          }
        </div>
      </div>
    </div>
  </div>
}
